import React, { PureComponent } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { BitbucketIcon } from '@atlaskit/logo';
import { BitbucketIcon as BitbucketIconRefresh } from '@atlaskit/temp-nav-app-icons/bitbucket';
import Tooltip from '@atlaskit/tooltip';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { Expander } from 'src/components/sidebar';
import { RouteComponentProps } from 'src/router/types';
import { withRouter } from 'src/router/utils';
import urls from 'src/urls/source';

import messages from './new-user-card.i18n';

type InjectedProps = {
  intl: InjectedIntl;
} & RouteComponentProps;

type Props = {
  isCollapsed?: boolean;
};

class NewUserCard extends PureComponent<Props & InjectedProps> {
  static defaultProps = {
    isCollapsed: false,
  };

  render() {
    const isBitbucketLogoRefreshEnabled = FeatureGates.checkGate(
      StatsigFeatureKeys.bitbucketLogoRefresh
    );

    const label = this.props.intl.formatMessage(messages.header);
    const icon = isBitbucketLogoRefreshEnabled ? (
      <BitbucketIconRefresh size="24" />
    ) : (
      <BitbucketIcon label={label} />
    );

    if (this.props.isCollapsed) {
      return (
        <Tooltip position="left" content={label}>
          {icon}
        </Tooltip>
      );
    }

    const contentValues = {
      guide: (
        <a href={urls.external.gettingStarted} target="_blank">
          getting started guide
        </a>
      ),
    };

    return (
      <Expander icon={icon} label={label}>
        <p>
          <FormattedMessage {...messages.intro} />
        </p>
        <p>
          <FormattedMessage {...messages.contents} values={contentValues} />
        </p>
      </Expander>
    );
  }
}

export default withRouter(injectIntl(NewUserCard));
